import { SupportedLinkWrappers } from '../constants.js';
import { SKIMLINKS_WRAP_HOST, TRACKONOMICS_WRAP_HOST } from './constants';
function isHostWithProtocol(subject, hostName) {
    return (
    // http:// check
    subject.substring(7, 7 + hostName.length) === hostName ||
        // https:// check
        subject.substring(8, 8 + hostName.length) === hostName);
}
/**
 * determines if the supplied string or URL object represents a skimlinks url
 */
export function isSkimlinksUrl(subject) {
    if (subject instanceof URL) {
        return subject.host === SKIMLINKS_WRAP_HOST;
    }
    return isHostWithProtocol(subject, SKIMLINKS_WRAP_HOST);
}
/**
 * determines if the supplied string or URL object represnts a trackonomics url
 */
export function isTrackonomicsUrl(subject) {
    if (subject instanceof URL) {
        return subject.host === TRACKONOMICS_WRAP_HOST;
    }
    return isHostWithProtocol(subject, TRACKONOMICS_WRAP_HOST);
}
/** merge a offer defintion with a contextual definition (article/page) */
export function mergeLinkWrapperDefinitions(offerDefinitions, contextDefinitions) {
    const checkList = new Set(SupportedLinkWrappers);
    const simpleMerge = offerDefinitions.map((wrapper) => {
        checkList.delete(wrapper.vendor);
        if (wrapper.disabled === true) {
            return wrapper;
        }
        const contextVendor = contextDefinitions[wrapper.vendor];
        if (contextVendor?.disabled === true) {
            return {
                disabled: true,
                vendor: wrapper.vendor,
            };
        }
        return { ...contextVendor, ...wrapper };
    });
    // backfill missing vendor defaults
    // @todo this is horrible.  The idea of having them as a stack instead of a vendor map was a mistake
    checkList.forEach((vendor) => vendor === 'Trackonomics'
        ? simpleMerge.push(contextDefinitions[vendor])
        : simpleMerge.unshift(contextDefinitions[vendor]));
    return simpleMerge;
}
/**
 * disable linkwrapper configs for a specific vendor or vendors in a BaseCommerceSingleEmbed
 */
export function disableLinkWrapVendors(embedConf, enabled) {
    embedConf.options = embedConf.options ?? {};
    if (embedConf.options.linkWrappers !== undefined) {
        embedConf.options.linkWrappers = disableLinkWrappersInConfigArray(embedConf.options.linkWrappers, enabled);
    }
    embedConf.options.linkWrappersByIdentifier = {
        ...{ default: SupportedLinkWrappers.map((vendor) => ({ vendor })) },
        ...(embedConf.options.linkWrappersByIdentifier ?? {}),
    };
    for (const [linkId, conf] of Object.entries(embedConf.options.linkWrappersByIdentifier)) {
        embedConf.options.linkWrappersByIdentifier[linkId] = disableLinkWrappersInConfigArray(conf, enabled);
    }
    return embedConf;
}
export function disableLinkWrappersInConfigArray(configs, disabled) {
    return configs.map((conf) => ({ ...conf, ...{ disabled: disabled[conf.vendor] } }));
}
//# sourceMappingURL=utility.js.map